import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import UserAccountRegistrationDto from '../dto/UserAccountRegistrationDto';

class UserAccountService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'userAccountControl';
	}

	/**
	 * @param {UserAccountRegistrationDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/register`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new UserAccountService();
